import { ChevronLeft, ChevronRight } from 'lucide-react';

// Page controls for a long list held in the page: "1–50 of 230", the pages
// (first, last and those either side of this one), and how many per page.
// page is 1-based; the caller slices its list with pageSlice.
export const pageSlice = (list, page, size) => list.slice((page - 1) * size, page * size);
export const pageCount = (total, size) => Math.max(1, Math.ceil(total / size));

function pagesAround(page, pages) {
  const want = new Set([1, pages, page - 1, page, page + 1].filter((p) => p >= 1 && p <= pages));
  const out = [];
  [...want].sort((a, b) => a - b).forEach((p, i, all) => {
    if (i && p - all[i - 1] > 1) out.push(`gap${p}`);
    out.push(p);
  });
  return out;
}

export default function Pager({ total, page, size, onPage, onSize, sizes = [25, 50, 100], label = 'items' }) {
  if (!total) return null;
  const pages = pageCount(total, size);
  const first = (page - 1) * size + 1;
  const last = Math.min(total, page * size);
  return (
    <nav className="pager" aria-label="Pages">
      <span className="small muted">{first}–{last} of {total} {label}</span>
      {pages > 1 && (
        <span className="pager-pages">
          <button type="button" className="btn icon-only" aria-label="Previous page" disabled={page <= 1} onClick={() => onPage(page - 1)}><ChevronLeft size={16} aria-hidden="true" /></button>
          {pagesAround(page, pages).map((p) => (typeof p === 'string'
            ? <span key={p} className="pager-gap" aria-hidden="true">…</span>
            : <button key={p} type="button" className={`btn pager-n${p === page ? ' on' : ''}`} aria-current={p === page ? 'page' : undefined} onClick={() => onPage(p)}>{p}</button>))}
          <button type="button" className="btn icon-only" aria-label="Next page" disabled={page >= pages} onClick={() => onPage(page + 1)}><ChevronRight size={16} aria-hidden="true" /></button>
        </span>
      )}
      {onSize && (
        <select value={size} onChange={(e) => onSize(Number(e.target.value))} aria-label="Per page">
          {sizes.map((n) => <option key={n} value={n}>{n} per page</option>)}
        </select>
      )}
    </nav>
  );
}
